import * as amplitude from '@amplitude/analytics-browser';
import { AmplitudeEventType } from 'src/interfaces/idashboard';

export const logAmplitudeEvent = (
  eventType: AmplitudeEventType,
  eventProperties: { [index: string]: string | boolean | number } = {}
) => {
  try {
    amplitude.track(eventType, eventProperties);
  } catch (error) {
    console.error('Amplitude event tracking failed: ', error, 'Event: ', eventType);
  }
};
